'use strict';

angular.module('utils').factory('OCAddressUtil', function() {
  return {
    addressAsString: function(addressObj) {
      var values = [];
      var keys = ['route', 'locality', 'administrative_area_level_1', 'country', 'postal_code'];

      angular.forEach(addressObj, function(value, key) {
        if (keys.indexOf(key) !== -1) {
          values.push(value);
        }
      });

      // default street number with blank
      if (!addressObj || !addressObj.street_number) {
        addressObj = addressObj || {};
        addressObj.street_number = addressObj.street_number || '';
      }

      // Prepend with street number without comma
      return '' + addressObj.street_number + ' ' + values.join(', ');
    },

    map: {
      checkPlace: function(place) {
        return !!(place && place.types && ['premise', 'street_address'].indexOf(place.types[0]) >= 0 && place.geometry);
      },
      parsePlace: function(place) {
        if (!this.checkPlace(place)) {
          return;
        }

        var result = {
          address: {},
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng(),
        };

        angular.forEach(place.address_components, function(addressComponent) {
          result.address[addressComponent.types[0]] = addressComponent.long_name;
          // Store 2-chars abbreviation of the state.
          if (addressComponent.types[0] == 'administrative_area_level_1') {
            result.address[addressComponent.types[0] + '_short'] = addressComponent.short_name;
          }
        });

        // Sometimes geocoder response doesn't contain `locality` attribute that is required for API.
        // For example: http://maps.googleapis.com/maps/api/geocode/json?address=6414%20Bay%20Pkwy,%20New%20York,%20United%20States,%2011204
        // In this case use value of `sublocality_level_1` or `sublocality` attribute.
        if (!result.address.locality && result.address.route && result.address.administrative_area_level_1) {
          result.address.locality = result.address.sublocality_level_1 || result.address.sublocality;
        }

        if (!result.address.postal_code && result.address.postal_code_prefix) {
          result.address.postal_code = result.address.postal_code_prefix;
          delete result.address.postal_code_prefix;
        }

        return result;
      },
    },
  };
});
